import React from 'react';

const InsuranceReport = () => {
    return (
        <div>
            <h2>Insurance Report</h2>
            {/* 这里可以放表格或列表组件 */}
        </div>
    );
};

export default InsuranceReport;
